(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["girlow-discount"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('.gd__code');
  if(!b)return;
  var c=b.getAttribute('data-code');
  var done=function(){var m=b.querySelector('em');if(m){m.textContent='Copiato!';setTimeout(function(){m.textContent='Copia'},1800);}};
  if(navigator.clipboard){navigator.clipboard.writeText(c).then(done);}else{done();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["girlow-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var M = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
  function fmt(d) { return d.getDate() + ' ' + M[d.getMonth()]; }
  function add(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
  function init() {
    document.querySelectorAll('.gx').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var main = root.querySelector('#gx-main');
      var thumbs = root.querySelectorAll('.gx__thumb');
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (main) main.src = btn.dataset.src;
          thumbs.forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');
        });
      });
      var copy = root.querySelector('.gx__copy');
      if (copy) copy.addEventListener('click', function () {
        var label = copy.querySelector('span');
        if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.code).catch(function () {});
        if (label) { label.textContent = 'Copiato'; setTimeout(function () { label.textContent = 'Copia'; }, 1800); }
      });
      var d = root.dataset;
      var ship = root.querySelector('[data-step=ship]');
      var del = root.querySelector('[data-step=del]');
      if (ship) ship.textContent = fmt(add(+d.shipMin)) + ' - ' + fmt(add(+d.shipMax));
      if (del) del.textContent = fmt(add(+d.delMin)) + ' - ' + fmt(add(+d.delMax));
      var data = root.querySelector('.gx__variants');
      var selects = root.querySelectorAll('.gx__select');
      if (data && selects.length) {
        var variants = JSON.parse(data.textContent);
        var idEl = root.querySelector('.gx__id');
        var btnEl = root.querySelector('.gx__btn');
        var stockEl = root.querySelector('.gx__stock');
        var priceEl = root.querySelector('#gx-price');
        var nf;
        try { nf = new Intl.NumberFormat('it-IT', { style: 'currency', currency: d.currency || 'EUR' }); } catch (e) { nf = null; }
        var onChange = function () {
          var vals = [];
          selects.forEach(function (s) { vals[+s.dataset.pos] = s.value; });
          var m = variants.find(function (v) {
            return vals.every(function (val, i) { return v['option' + (i + 1)] === val; });
          });
          if (!m) return;
          if (idEl) idEl.value = m.id;
          if (priceEl && nf) priceEl.textContent = nf.format(m.price / 100);
          if (stockEl) stockEl.hidden = !m.available;
          if (btnEl) { btnEl.disabled = !m.available; btnEl.textContent = m.available ? 'Aggiungi al carrello' : 'Esaurito'; }
          if (m.featured_image && m.featured_image.src && main) {
            main.src = m.featured_image.src;
            thumbs.forEach(function (b) { b.classList.remove('is-on'); });
          }
          try { history.replaceState(null, '', '?variant=' + m.id); } catch (e) {}
        };
        selects.forEach(function (s) { s.addEventListener('change', onChange); });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
